<template>
    <div>

        <trax-ui-simple-table
            :id="id" :header="0" :rows="rows" :cols="cols" :bus="bus">
        </trax-ui-simple-table>

        <!-- Progress files confirmation, and the choice of the lane -->

        <trax-ui-modal-default :id="id+'-progress-files'" :bus="bus"
            :title="lang.polaris.dashboard.all_progress_files">

            <p>{{ lang.polaris.dashboard.confirm_all_progress_files_q }}</p>

            <div class="text-right mt-4">
                <trax-ui-checkbox :text="lang.polaris.tasks.night_run" v-model="atNight"></trax-ui-checkbox>
            </div>

            <div class="trax-form-actions text-right">
                <button type="button" class="btn btn-default btn-link" data-dismiss="modal">
                    {{ lang.polaris.form.cancel }}
                </button>
                <button type="button" class="btn btn-danger btn-round" data-dismiss="modal" @click="generateProgressFiles">
                    {{ lang.polaris.form.confirm }}
                </button>
            </div>
        </trax-ui-modal-default>

        <!-- Progress files cancellation confirmation -->

        <trax-ui-modal-confirm :id="id+'-cancel-progress-files'" :bus="bus"
            :title="lang.polaris.dashboard.cancel_all_progress_files">
            {{ lang.polaris.dashboard.confirm_cancel_all_progress_files_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: { default: 'enac-atpl-dashboard-registration-program' }
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                registration: data.registration,
                endpoint: app_url+'polaris/api/front/export/registrations/'+data.registration.id,
                cols: [
                    {class: 'font-weight-bold'},
                    {class: 'text-right'},
                ],
                rows: [],

                // The generation is heavy: it waits for the night unless the user says otherwise.
                atNight: true,

                // State of the generation of the progress files of the whole group.
                task: null,
                queue: null,
                progressFiles: {count: 0, size: 0, size_label: ''},
                timer: null,

                bus: this.$bus
            }
        },

        computed: {

            exportPermission: function() {
                return this.user.admin || this.user.permissions['export.generate'];
            },

            fullPermission: function() {
                return this.user.admin || this.user.permissions['export.access-zip-file'];
            },

            // The generation is waiting for the runner, or running.
            taskRunning: function() {
                if (!this.task) return false;
                return ['pending', 'running', 'cancelling'].indexOf(this.task.status) >= 0;
            },

            taskFailed: function() {
                return this.task && this.task.status == 'failed';
            },

            // What the generation of the group is doing. A batch waits for its learners far longer
            // than it runs, so the number of learners left is what has to be shown while it is
            // queued.
            taskLabel: function() {
                if (!this.task) return '';
                var label = this.lang.polaris.tasks[this.task.status];

                if (this.task.status == 'pending' && this.task.lane == 'night') {
                    label += ' (' + this.lang.polaris.tasks.night_run + ')';
                }
                if (this.task.status == 'pending' && this.queue) {
                    label += ' - ' + this.lang.polaris.dashboard.progress_files_waiting
                        .replace(':done', this.queue.done)
                        .replace(':total', this.queue.total);
                }
                if (this.task.status == 'running' && this.task.progress_total) {
                    label += ' ' + this.task.progress + '/' + this.task.progress_total;
                }
                return label;
            },

            // What came out of the last generation. It is the only place which knows that a learner
            // was expected and has no file.
            reportLabel: function() {
                if (!this.task || this.taskRunning || !this.task.report) return '';

                var label = this.lang.polaris.dashboard.progress_files_generated
                    .replace(':found', this.task.report.found)
                    .replace(':expected', this.task.report.expected);

                if (this.task.report.missing && this.task.report.missing.length) {
                    label += ' - ' + this.lang.polaris.dashboard.progress_files_missing
                        .replace(':count', this.task.report.missing.length);
                }
                return label;
            }
        },

        created: function() {
            this.getStates();
            this.bus.$on(this.id+'-cancel-progress-files-confirmed', this.cancelProgressFiles);
        },

        beforeDestroy: function() {
            this.stopPolling();
        },

        mounted: function() {
            var that = this;

            // Queuing every learner needs a confirmation, so it does not go through the generic
            // ajax buttons of this table.
            $('body').on("click", "#"+this.id+"-table button.progress-files-button", function() {
                that.bus.$emit(that.id+'-progress-files-open');
            });

            $('body').on("click", "#"+this.id+"-table button.cancel-progress-files-button", function() {
                that.bus.$emit(that.id+'-cancel-progress-files-open');
            });

            $('body').on("click", "#"+this.id+"-table button.ajax-button", function() {
                var endpoint = $(this).data('endpoint');
                that.bus.$emit('loader-start-loading');
                axios.post(endpoint)
                    .then(function (response) {
                        that.setState(response.data);
                        that.bus.$emit('loader-stop-loading');
                    })
                    .catch(function (error) {
                        that.bus.$emit('loader-stop-loading');
                    });
            });
        },

        methods: {

            getStates() {
                var that = this;
                axios.get(this.endpoint)
                    .then(function (response) {
                        that.setState(response.data);
                    })
                    .catch(function (error) {
                    });
            },

            // The state always comes from the server, so that a page reload restores a running
            // generation, whoever started it.
            setState(payload) {
                this.task = payload.progress_files_task;
                this.queue = payload.progress_files_queue;
                this.progressFiles = payload.progress_files;
                this.initRows(payload.data);

                if (this.taskRunning) {
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            },

            startPolling() {
                if (this.timer) return;
                var that = this;
                this.timer = setInterval(function() {
                    axios.get(that.endpoint+'/progress-files/task')
                        .then(function (response) {
                            that.setState(response.data);
                        })
                        .catch(function (error) {
                            that.stopPolling();
                        });
                }, 3000);
            },

            stopPolling() {
                if (!this.timer) return;
                clearInterval(this.timer);
                this.timer = null;
            },

            initRows(items) {
                this.rows = [];

                // Keep the last flight hours item.
                var flightHours;
                var individualFlightHours;
                for(var index in items) {
                    var item = items[index];
                    if (item.type == 'flight_hours') flightHours = item;
                    if (item.type == 'individual_flight_hours') individualFlightHours = item;
                }

                // Total flight Hours
                this.rows.push([
                    'Total Flight Hours',
                    this.refreshFlightHours(flightHours) + this.generateFlightHours(flightHours) + this.downloadFlightHours(flightHours),
                ]);

                // Individual flight Hours
                this.rows.push([
                    'Individual Flight Hours',
                    this.generateIndividualFlightHours(individualFlightHours) + this.downloadIndividualFlightHours(individualFlightHours),
                ]);

                // Row Data item
                var rawData;
                for(var index in items) {
                    var item = items[index];
                    if (item.type == 'raw_data') rawData = item;
                }

                // Row Data
                this.rows.push([
                    this.lang.polaris.dashboard.raw_data,
                    this.generateRawData(rawData) + this.downloadRawData(rawData),
                ]);

                // Progress files of every learner
                if (this.fullPermission) {
                    this.rows.push([
                        this.progressFilesLabel(),
                        this.generateProgressFilesButton()
                            + this.cancelProgressFilesButton()
                            + this.downloadProgressFilesButton(),
                    ]);
                }
            },

            progressFilesLabel() {
                var html = this.lang.polaris.dashboard.progress_files;
                if (this.taskRunning) {
                    html += '<br><small class="text-dark">' + this.taskLabel + '</small>';
                } else if (this.taskFailed) {
                    html += '<br><small class="text-danger">' + this.taskLabel + '</small>';
                } else if (this.reportLabel) {
                    html += '<br><small class="text-dark">' + this.reportLabel + '</small>';
                }
                return html;
            },

            generateProgressFilesButton() {
                if (!this.exportPermission) return '';
                var disabled = this.taskRunning ? 'disabled' : '';
                var html = '<button type="button" '+disabled+' class="btn btn-white btn-sm ml-1 progress-files-button">';
                if (this.taskRunning) html += '<i class="material-icons trax-spin">autorenew</i> ';
                html += lang.polaris.dashboard.generate_all_progress_files;
                html += '</button>';
                return html;
            },

            cancelProgressFilesButton() {
                if (!this.exportPermission || !this.taskRunning) return '';
                var html = '<button type="button" class="btn btn-white btn-sm ml-1 cancel-progress-files-button">';
                html += lang.polaris.tasks.cancel;
                html += '</button>';
                return html;
            },

            // Nothing is generated here: the ZIP is assembled from the individual progress files at
            // download time. It is disabled during a generation, which is rewriting those files.
            downloadProgressFilesButton() {
                var href = this.endpoint+'/progress-files/file';
                var disabled = !this.progressFiles.count || this.taskRunning ? 'disabled' : '';
                var html = '<button type="button" onclick="window.open(\''+href+'\')" '+disabled+' class="btn btn-primary btn-sm ml-1">';
                html += lang.polaris.dashboard.download_all_progress_files;
                if (this.progressFiles.count) {
                    html += '<br><small>' + this.lang.polaris.dashboard.progress_files_available
                        .replace(':count', this.progressFiles.count)
                        .replace(':size', this.progressFiles.size_label) + '</small>';
                }
                html += '</button>';
                return html;
            },

            // One task per learner, and a last one which closes the batch. Learners already queued
            // are left alone, so clicking twice does not double the work.
            generateProgressFiles() {
                var that = this;
                this.bus.$emit('loader-start-loading');
                axios.post(this.endpoint+'/progress-files', {lane: this.atNight ? 'night' : 'now'})
                    .then(function (response) {
                        that.setState(response.data);
                        that.bus.$emit('loader-stop-loading');
                        that.bus.$emit(that.id+'-toastr-success', that.queuedMessage(response.data));
                    })
                    .catch(function (error) {
                        that.bus.$emit('loader-stop-loading');
                        var message = error.response && error.response.data ? error.response.data.message : undefined;
                        that.bus.$emit(that.id+'-toastr-error', message);
                    });
            },

            cancelProgressFiles() {
                var that = this;
                this.bus.$emit('loader-start-loading');
                axios.post(this.endpoint+'/progress-files/cancel')
                    .then(function (response) {
                        that.setState(response.data);
                        that.bus.$emit('loader-stop-loading');
                        that.bus.$emit(that.id+'-toastr-success', that.lang.polaris.dashboard.progress_files_cancelled);
                    })
                    .catch(function (error) {
                        that.bus.$emit('loader-stop-loading');
                        var message = error.response && error.response.data ? error.response.data.message : undefined;
                        that.bus.$emit(that.id+'-toastr-error', message);
                    });
            },

            queuedMessage(data) {
                if (!data.learners) {
                    return this.lang.polaris.dashboard.no_progress_files_to_generate;
                }
                if (!data.created) {
                    return this.lang.polaris.dashboard.progress_files_already_queued;
                }
                var message = this.atNight
                    ? this.lang.polaris.dashboard.progress_files_queued
                    : this.lang.polaris.dashboard.progress_files_queued_now;

                return message.replace(':count', data.created);
            },

            refreshFlightHours(item) {
                var endpoint = this.endpoint+'/flight-hours/refresh';
                var html = '<button type="button" data-endpoint="'+endpoint+'" class="btn btn-white btn-sm ml-1 ajax-button">';
                html += 'Refresh';
                html += '</button>';
                return html;
            },

            generateFlightHours(item) {
                if (!this.exportPermission) return '';
                var endpoint = this.endpoint+'/flight-hours/generate';
                var html = '<button type="button" data-endpoint="'+endpoint+'" class="btn btn-white btn-sm ml-1 ajax-button">';
                html += lang.polaris.dashboard.generate + ' CSV';
                if (item) html += '<br><small>' + this.compactTimestamp(item.updated_at) + '</small>';
                html += '</button>';
                return html;
            },

            downloadFlightHours(item) {
                var href = this.endpoint+'/flight-hours/file';
                var disabled = item ? '' : 'disabled';
                var html = '<button type="button" onclick="window.open(\''+href+'\')" '+disabled+' class="btn btn-primary btn-sm ml-1">';
                html += lang.polaris.dashboard.download + ' CSV';
                html += '</button>';
                return html;
            },

            generateIndividualFlightHours(item) {
                if (!this.exportPermission) return '';
                var endpoint = this.endpoint+'/individual-flight-hours/generate';
                var html = '<button type="button" data-endpoint="'+endpoint+'" class="btn btn-white btn-sm ml-1 ajax-button">';
                html += lang.polaris.dashboard.generate + ' ZIP';
                if (item) html += '<br><small>' + this.compactTimestamp(item.updated_at) + '</small>';
                html += '</button>';
                return html;
            },

            downloadIndividualFlightHours(item) {
                var href = this.endpoint+'/individual-flight-hours/file';
                var disabled = item ? '' : 'disabled';
                var html = '<button type="button" onclick="window.open(\''+href+'\')" '+disabled+' class="btn btn-primary btn-sm ml-1">';
                html += lang.polaris.dashboard.download + ' ZIP';
                html += '</button>';
                return html;
            },

            generateRawData(item) {
                if (!this.exportPermission) return '';
                var endpoint = this.endpoint+'/raw-data';
                var html = '<button type="button" data-endpoint="'+endpoint+'" class="btn btn-white btn-sm ml-1 ajax-button">';
                html += lang.polaris.dashboard.generate + ' CSV';
                if (item) html += '<br><small>' + this.compactTimestamp(item.updated_at) + '</small>';
                html += '</button>';
                return html;
            },

            downloadRawData(item) {
                var href = this.endpoint+'/raw-data/file';
                var disabled = item ? '' : 'disabled';
                var html = '<button type="button" onclick="window.open(\''+href+'\')" '+disabled+' class="btn btn-primary btn-sm ml-1">';
                html += lang.polaris.dashboard.download + ' CSV';
                html += '</button>';
                return html;
            },

            compactTimestamp(timestamp) {
                return moment(timestamp).format('DD/MM/YYYY H:mm:ss');
            }
        }
    }
</script>
